/** APS `x-ads-region` values for Data Management / derivative calls. */
export type DmAdsRegion = "US" | "EMEA";

/** Map hub `attributes.region` from GET /hubs to an optional DM region header. */
export function dmRegionFromHub(hubRegion?: string): DmAdsRegion | undefined {
  if (!hubRegion) return undefined;
  const r = hubRegion.toUpperCase();
  if (r === "EMEA") return "EMEA";
  if (r === "US") return "US";
  return undefined;
}
